import React, { useEffect, useRef, useState } from "react";
import { Box, Typography, Paper, Grid, Skeleton, Card } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Bar } from 'react-chartjs-2';
import axios from "axios";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { authState, popupState } from "../../Recoil/RecoilState";
import { chartColors, baseURL } from "../../utils/StaticVariables";
import DesBtn from "../Reusable/DesBtn";
import OrderFilter from "./OrderFilter";

const commonOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: 'top', labels: { color: 'gray' } },
    title: { display: false }
  },
  scales: {
    x: { ticks: { color: 'gray' } },
    y: { ticks: { color: 'gray' } }
  }
};

const TrafficInsightsChart = () => {
  const [trafficData, setTrafficData] = useState(null);
  const [regionalData, setRegionalData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useRecoilValue(authState);
  const setPopup = useSetRecoilState(popupState);
  const childRef = useRef(null);
  const [filter, setFilter] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const params = { ...filter };
        if (params.locations) { params.location = params.locations; delete params.locations; }
        if (params.buildings) { params.building = params.buildings; delete params.buildings; }
        if (params.zones) { params.zone = params.zones; delete params.zones; }

        const trafficPromise = axios.get(`${baseURL}shoplifting/dashboard/session-insights`, {
          headers: { Authorization: `Bearer ${token}` },
          params
        });

        const regionalPromise = axios.get(`${baseURL}shoplifting/dashboard/regional-risk`, {
          headers: { Authorization: `Bearer ${token}` },
          params
        });

        const [trafficRes, regionalRes] = await Promise.all([trafficPromise, regionalPromise]);
        
        setTrafficData(trafficRes.data);
        setRegionalData(regionalRes.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    if (token) fetchData();
  }, [filter, token]);

  const openFilter = () => {
    setPopup({
      isOpen: true,
      title: "Select Date, Time and Location Filters",
      content: (
        <OrderFilter ref={childRef} filter={filter} changeFilterHandle={setFilter} />
      ),
      sendReq: () => childRef.current?.submit(),
    });
  };

  const avg_behavior_per_session = trafficData?.avg_behavior_per_session || [];
  const incidents_data = regionalData?.incidents_per_1000_sessions || [];

  const behaviorLabels = avg_behavior_per_session.map(item => item.location || item.zone || 'Unknown');
  const behaviorData = avg_behavior_per_session.map(item => item.session_count || 0);
 console.log("TrafficInsightsChart - Behavior Labels:", behaviorLabels);
console.log("TrafficInsightsChart - Behavior Data:", behaviorData);
  console.log("TrafficInsightsChart - Incidents Data:", incidents_data);
  return (
    <Card sx={{ p: 2, height: 'auto', bgcolor: 'background.paper', mb: 2 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
         <Typography variant="h6">Store Traffic & Regional Benchmark Insights</Typography>
         <DesBtn text="Filter" handle={openFilter}>
          <FilterAltOutlinedIcon />
         </DesBtn>
      </Box>

      {loading || (!trafficData && !regionalData) ? (
        <Skeleton variant="rectangular" height="400px" sx={{ borderRadius: 2 }} />
      ) : (
        <Grid container spacing={3} sx={{ height: 400 }}>
           <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 2, height: '100%', bgcolor: 'background.paper' }}>
              <Typography variant="subtitle1" mb={2}>Average Behaviors Detected per Session by Zone</Typography>
              <Box sx={{ height: 320 }}>
                <Bar 
                  data={{
                    labels: behaviorLabels.length ? behaviorLabels : ['No Data'],
                    datasets: [{ label: 'Avg Behaviors', data: behaviorData.length ? behaviorData : [0], backgroundColor: chartColors[4] }]
                  }}
                  options={commonOptions}
                />
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={0} sx={{ p: 2, height: '100%', bgcolor: 'background.paper' }}>
              <Typography variant="subtitle1" mb={2}>Regional Risk: Incidents per 1000 Sessions (Top 5)</Typography>
              <Box sx={{ height: 320 }}>
                {incidents_data.length > 0 ? (
                  <Bar 
                    data={{
                      labels: incidents_data.map(r => r.region || r.location || r.zone || 'Unknown'),
                      datasets: [{ label: 'Rate / 1k', data: incidents_data.map(r => r.incidents_per_1000_sessions || 0), backgroundColor: chartColors[5] }]
                    }}
                    options={{...commonOptions, indexAxis: 'y'}}
                  />
                ) : (
                  <Bar 
                    data={{
                      labels: ['Los Angeles', 'New York', 'Chicago', 'Houston', 'Miami'],
                      datasets: [{ label: 'Rate / 1k', data: [112, 98, 85, 45, 30], backgroundColor: chartColors[5] }]
                    }}
                    options={{...commonOptions, indexAxis: 'y'}}
                  />
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

export default TrafficInsightsChart;                              
